// import React from 'react'
// import {styled} from '@mui/material/styles'
// import { Stack, TextField } from "@mui/material";
// import { DateTimePicker } from '@mui/x-date-pickers';

// export const MuiPicker = (props) => {

//     const changeDate = (newValue) => {
//         props.setSomethingWasChanged(true)
//         props.setNewEvent({...props.newEvent, time: isValid(newValue) ? format(newValue, 'p') : null, dateTime: newValue})
//     }
//     return(
//         <Stack spacing={4} sx={{width: '250px'}}>
//             <DateTimePicker
//                 label='Date/Time Picker' 
//                 renderInput={(params) => <TextField {...params} />} 
//                 value={props.newEvent.dateTime}
//                 onChange={(newValue) => changeDate(newValue)}
//             />
//         </Stack>
//     )
// }


import React from 'react';
import {TextField} from '@mui/material';
import { format, isValid, parseISO } from 'date-fns';

export const MuiPicker = (props) => {

  React.useEffect(() => {
    props.setNewEvent({...props.newEvent, time: format(new Date(props.newEvent.dateTime), 'h:mm a') ? format(new Date(props.newEvent.dateTime), 'p') : null})
  }, [])

  const changeDate = (newValue) => {
      props.setSomethingWasChanged(true)
      props.setNewEvent({...props.newEvent, time: format(new Date(newValue), 'h:mm a') ? format(new Date(newValue), 'p') : null, dateTime: newValue})
  }

  const date = props.newEvent.dateTime
  let localDate;
  if(typeof date === 'string') {
    localDate = date && date.slice(0, 16);
  } else if (date === undefined) {

  } else {
    let stringedDate = date && format(date, 'yyyy-MM-dd\'T\'HH:mm');
    localDate = stringedDate.slice(0, 16);
  }

    
    // ...
    return (
      <TextField
      id="datetime-local"
      label="Lesson Time"
      type="datetime-local"
      value={localDate}
      onChange={(e) => changeDate(e.target.value)}
      InputLabelProps={{shrink: true,}}
    />
    )
}
